import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface HoldoverCarton {
  product_uuid: string; barcode: string; store_number: string; customer_name: string;
  trip_number: string; source_asn: string; source_bol: string; shipment_list_uuid: string;
  package_uuid: string | null; holdover_trip_uuid: string | null; first_received_on: string | null;
  date: string | null; recency_date: string; date_source: string; modified: string | null;
  return_status: string | null; carton_resolution: string | null;
  eligible: boolean; pending_destination: boolean; held: boolean; category: string; reasons: string[]; fingerprint: string;
}
export interface HoldoverSelection {
  pool_point_uuid: string; products: { product_uuid: string; fingerprint: string }[];
  reason: string; release_holds: boolean;
}
export interface HoldoverPreview {
  permissions?: { view: boolean; create: boolean };
  carton_count: number; held_count: number; pending_destination_count: number;
  groups: { key: string; pending_destination: boolean; customer: string; store_number: string; source_asn: string; source_bol: string; cartons: number }[];
}
export interface HoldoverResult {
  trip: { trip_list_uuid: string; trip_number: string; asn_number: string };
  products: { product_uuid: string; barcode: string; store_number: string; package_uuid: string | null; allocated: boolean; pending_destination: boolean; source_asn: string; source_bol: string }[];
  replayed?: boolean;
}
export interface ProductHistory {
  product_history_uuid: string; event_type: string; recorded_at: string; reason: string | null;
  before_state: { trip_number?: string; asn_number?: string; date?: string; first_received_on?: string };
  after_state: { trip_number?: string; asn_number?: string; date?: string; first_received_on?: string };
}
@Injectable({ providedIn: 'root' })
export class HoldoverCartonsApiService {
  private readonly url = '/api/holdovers/holdovers.php';
  constructor(private http: HttpClient) {}
  candidates(pool: string) {
    return this.http.get<{ data: HoldoverCarton[]; counts: Record<string, number>; observed_at: string; pools: { pool_point_uuid: string; pool_point_name: string }[]; permissions: { view: boolean; create: boolean } }>(this.url, { params: { action: 'candidates', pool_point_uuid: pool } });
  }
  preview(input: HoldoverSelection) { return this.http.post<HoldoverPreview>(this.url, input, { params: { action: 'preview' } }); }
  create(input: HoldoverSelection, key: string) {
    return this.http.post<HoldoverResult>(this.url, input, { params: { action: 'create' }, headers: new HttpHeaders({ 'Idempotency-Key': key }) });
  }
  detail(uuid: string) { return this.http.get<HoldoverResult>(this.url, { params: { action: 'detail', uuid } }); }
  history(uuid: string) { return this.http.get<{ data: ProductHistory[] }>(this.url, { params: { action: 'history', uuid } }); }
}
